import { render, staticRenderFns } from "./PersonalizationMicrosoftStep3.vue?vue&type=template&id=6bce9499&scoped=true"
import script from "./PersonalizationMicrosoftStep3.vue?vue&type=script&lang=js"
export * from "./PersonalizationMicrosoftStep3.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationMicrosoftStep3.vue?vue&type=style&index=0&id=6bce9499&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bce9499",
  null
  
)

export default component.exports